module.exports = __webpack_public_path__ + "assets/media/evening.599b8db7.mp3";